// Todo V.: This should be checked by a Greek person
var phrases = {
    calendarLabel: 'Ημερολόγιο',
    roleDescription: 'επιλογή δεδομένων',
    closeDatePicker: 'Κλείσε',
    focusStartDate: 'Αλληλεπιδράστε με το ημερολόγιο και προσθέστε την ημερομηνία για την οποία θέλετε να δείτε τα νέα.',
    clearDate: 'Εκκαθάριση της ημερομηνίας',
    clearDates: 'Εκκαθάριση των ημερομηνιών',
    jumpToPrevMonth: 'Μετακίνηση προς τα πίσω για μετάβαση στον προηγούμενο μήνα.',
    jumpToNextMonth: 'Προχωρήστε προς τα εμπρός για μετάβαση στον επόμενο μήνα.',
    openThisPanel: 'Ανοίξτε αυτό το πλαίσιο.',
    enterKey: 'εισάγετε πλήκτρο',
    leftArrowRightArrow: 'Πλήκτρα δεξιού και αριστερού βέλους',
    upArrowDownArrow: 'πάνω και κάτω βέλη',
    pageUpPageDown: 'πλήκτρα σελίδας πάνω και κάτω σελίδας',
    homeEnd: 'πλήκτρα σπιτιού και τερματισμού',
    escape: 'πλήκτρο διαφυγής',
    questionMark: 'Ερωτηματικό',
    selectFocusedDate: 'Επιλέξτε την ημερομηνία στο επίκεντρο.',
    moveFocusByOneDay: 'Μετακινηθείτε προς τα πίσω (αριστερά) και προς τα εμπρός (δεξιά) κατά μία ημέρα.',
    moveFocusByOneWeek: 'Μετακινηθείτε προς τα πίσω (πάνω) και προς τα εμπρός (κάτω) κατά μία εβδομάδα.',
    moveFocusByOneMonth: 'Αλλαγή μηνών.',
    moveFocustoStartAndEndOfWeek: 'Πηγαίνετε στην πρώτη ή την τελευταία ημέρα της εβδομάδας.',
    returnFocusToInput: 'Επιστροφή στο πεδίο εισαγωγής ημερομηνίας.',
    keyboardForwardNavigationInstructions: 'Πλοηγηθείτε προς τα εμπρός για να αλληλεπιδράσετε με το ημερολόγιο και επιλέξτε μια ημερομηνία. '
        + 'Πατήστε το πλήκτρο ερωτηματικού για να λάβετε τις συντομεύσεις πληκτρολογίου για αλλαγή ημερομηνιών.',
    keyboardBackwardNavigationInstructions: 'Πλοηγηθείτε προς τα πίσω για να αλληλεπιδράσετε με το ημερολόγιο και επιλέξτε μια ημερομηνία. '
        + 'Πατήστε το πλήκτρο ερωτηματικού για να λάβετε τις συντομεύσεις πληκτρολογίου για αλλαγή ημερομηνιών.',
    chooseAvailableStartDate: function (_a) {
        var date = _a.date;
        return "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 " + date + " \u03C9\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 check-in. \u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF.";
    },
    chooseAvailableEndDate: function (_a) {
        var date = _a.date;
        return "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 " + date + " \u03C9\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B1\u03BD\u03B1\u03C7\u03CE\u03C1\u03B7\u03C3\u03B7\u03C2. \u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF.";
    },
    chooseAvailableDate: function (_a) {
        var date = _a.date;
        return date;
    },
    dateIsUnavailable: function (_a) {
        var date = _a.date;
        return "\u039C\u03B7 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C2. " + date;
    },
    dateIsSelected: function (_a) {
        var date = _a.date;
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF. " + date;
    },
    dateIsSelectedAsStartDate: function (_a) {
        var date = _a.date;
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C9\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2. " + date;
    },
    dateIsSelectedAsEndDate: function (_a) {
        var date = _a.date;
        return "\u0395\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C9\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2. " + date;
    },
};
export default phrases;
